<template>
  <div class="layout-head" :class="[logoPosition === 'center' && 'center-style', showHolidayLogo && 'need-left-spacing']" :style="headerStyle">
    <div v-if="showCompanyLogo && logoPosition !== 'center'" class="company-info">
      <div class="company-logo-wrapper" :class="companyThemeSetting && 'has-company-logo'">
        <img v-if="companyLogo" class="company-logo" :src="companyLogo"/>
      </div>
      <div v-if="showCompanyName" class="company-name">{{ companyName }}</div>
    </div>
    <div class="menu-list">
      <template v-if="isPreview || (customMenuList && customMenuList.length > 0)">
        <a
          v-for="(menu, index) in menuList"
          class="is-custom-menu menu link"
          :class="menu.isActive && 'is-active'"
          :key="index"
          :href="menu.path"
        >
        {{ menu.label || $t(menu.labelI18nKey) }}</a>
      </template>
      <template v-else-if="companyId">
        <router-link
          v-for="(menu, index) in menuList"
          class="menu link"
          :active-class="isActive(menu) ? 'is-active' : ''"
          :exact-active-class="isActive(menu) ? 'is-active': ''"
          :key="index"
          :to="menu.path"
        >{{ menu.label || $t(menu.labelI18nKey) }}</router-link>
      </template>
    </div>
    <div class="navigation-container">
      <slot name="userMenu">
        <div v-if="isLogin" class="navigation user">
          <HeaderUserMenu light-theme showDropDownArrow :isPreview="isPreview" :isMSDCompany="isMSDCompany" class="user-menu-dropdown">
            <template #dropdown-label>
              <i class="navigation-icon iconfont icona-MyApplications"></i>
            </template>
          </HeaderUserMenu>
        </div>
      </slot>
      <div v-if="languagePosition === 'left'" class="navigation language" @click="onLanguageBtnClick">{{ anotherLanguage }}</div>
      <router-link v-if="!isLogin && !isLoginPage" class="navigation login link" :to="loginPath">{{ $t('common.btn.signIn') }}</router-link>
      <div v-if="languagePosition === 'right'" class="navigation language" @click="onLanguageBtnClick">{{ anotherLanguage }}</div>
      <div v-if="showPhoneIcon" class="navigation contact">
        <i class="navigation-icon iconfont iconTelephone hotline-icon"></i>
        <div class="dropdown-container">
          <div class="hotline-list">
            <div class="detail-line">
              <span class="line-label">{{ $t('admin.layout.header.hotline.cnUser') }}</span>
              <span class="line-content phone">400-990-3308</span>
            </div>
            <div class="detail-line">
              <span class="line-label">{{ $t('admin.layout.header.hotline.allUser') }}</span>
              <span class="line-content email link">service@ajinga.com</span>
            </div>
          </div>
          <div class="dropdown-padding"></div>
          <div class="dropdown-arrow"></div>
        </div>
      </div>
    </div>
    <div v-if="showCompanyLogo && logoPosition === 'center'" class="company-info header-center">
      <div class="company-logo-wrapper" :class="companyThemeSetting && 'has-company-logo'">
        <img v-if="companyLogo" class="company-logo" :src="companyLogo"/>
      </div>
      <div v-if="showCompanyName" class="company-name">{{ companyName }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import { COMPANY_PAGE_TYPE, ROOT_COMPANY_ID } from '@/constant/company'
import { addQueryInPath, deviceType } from '@/utils/common'
import { ACCOUNT_TYPE } from '@/constant/common'
import { getI18nPropertyValue, isEn } from '@/i18n'
import { brandingRoute, landingRoute, jobListRoute } from '@/views/company/pc/route'
import { brandingRoute as MSDBrandingRoute, landingRoute as MSDLandingRoute, msdPcJobListRouteMap } from '@/views/company/msdCustomUrl/pc/route'
import { msdMobileJobListRouteMap } from '@/views/company/msdCustomUrl/mobile/route'
import mixin from '@/views/personalNew/layout/mixin'
import HeaderUserMenu from '@/components/layout/header/headerUserMenu.vue'
import { mapActions, mapGetters } from 'vuex'

const MSD_COMPANY_ID_LIST = [
  ROOT_COMPANY_ID.MSD,
  ROOT_COMPANY_ID.MSD_GHH,
  ROOT_COMPANY_ID.MSD_GSF,
  ROOT_COMPANY_ID.MSD_MAH,
  ROOT_COMPANY_ID.MSD_MMD,
  ROOT_COMPANY_ID.MSD_MRL,
  ROOT_COMPANY_ID.MSD_OLD
]

export default {
  directives: {
    Clickoutside
  },
  components: {
    HeaderUserMenu
  },
  props: {
    companyId: {
      required: false
    },
    customPage: {
      required: true
    },
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    isLoginPage: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    showHolidayLogo: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixin],
  data () {
    return {
    }
  },
  computed: {
    accountTypeList () {
      if (this.isPc) {
        return ACCOUNT_TYPE
      }
      const list = {}
      _.forEach(ACCOUNT_TYPE, (val, key) => {
        if (val === ACCOUNT_TYPE.AGENCY) {
          return
        }
        list[key] = val
      })
      return list
    },
    MSDCompanyId () {
      if (this.$route.meta?.customCompanyId) {
        return this.$route.meta?.customCompanyId
      }
      return ROOT_COMPANY_ID.MSD
    },
    loginPath () {
      if (this.isPreview) {
        return null
      }
      return `/passport/${ACCOUNT_TYPE.CANDIDATE}/register?back=${encodeURIComponent(window.location.href)}&company_id=${this.companyId}`
    },
    anotherLanguage () {
      if (isEn()) {
        return '简体中文'
      } else {
        return 'English'
      }
    },
    isLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account && account.id)
    },
    pageType () {
      return this.$route.meta?.pageType
    },
    isMSDCompany () {
      return _.includes(MSD_COMPANY_ID_LIST, this.companyId) || this.isMSDCustom
    },
    brandingRoute () {
      if (this.isMSDCompany) {
        return MSDBrandingRoute
      }
      return brandingRoute
    },
    landingRoute () {
      if (this.isMSDCompany) {
        return MSDLandingRoute
      }
      return landingRoute
    },
    msdJobListRouteMap () {
      return deviceType.isMobile ? msdMobileJobListRouteMap : msdPcJobListRouteMap
    },
    jobListRoute () {
      if (this.isMSDCompany) {
        return _.get(this.msdJobListRouteMap, this.MSDCompanyId)
      }
      return jobListRoute
    },
    landingPage () {
      return this.customPage?.landing_page
    },
    brandingPage () {
      return this.customPage?.branding_page
    },
    customMenuList () {
      return _.map(this.companyThemeSetting?.companyDetailSetting?.menuList, (item, index) => {
        return {
          path: item.link || '',
          get label () {
            return getI18nPropertyValue(item, 'label', 'enLabel')
          },
          isCustomMenu: true
        }
      })
    },
    menuList () {
      let totalMenuList = [
        {
          hidden: !this.brandingPage,
          label: this.brandingPage?.i18nName,
          path: this.brandingRoute.path,
          pageNum: this.brandingPage?.page_number,
          name: COMPANY_PAGE_TYPE.BRANDING
        },
        {
          hidden: !this.landingPage,
          label: this.landingPage?.i18nName,
          path: this.landingRoute.path,
          pageNum: this.landingPage?.page_number,
          name: COMPANY_PAGE_TYPE.LANDING
        },
        {
          path: this.jobListRoute.path,
          labelI18nKey: 'company.menu.jobList',
          name: COMPANY_PAGE_TYPE.JOB_LIST
        }
      ]
      if (!_.isEmpty(this.customMenuList)) {
        totalMenuList = this.customMenuList
      }

      const list = []
      const query = this.$route.query
      _.forEach(totalMenuList, menu => {
        if (menu.hidden) {
          return
        }
        if (this.isPreview) {
          menu.path = null
        } else {
          let path = menu.path
          if (path.includes(':companyId')) {
            path = path.replace(':companyId', this.companyId)
          }
          if (path.includes(':pageNum')) {
            path = path.replace(':pageNum', menu.pageNum)
          }
          const params = {
            aj_source: query.aj_source,
            aj_code: query.aj_code
          }
          path = addQueryInPath(path, params, true)
          menu.isActive = this.isActiveCustomMenu(path)
          menu.path = path
        }
        list.push(menu)
      })
      return list
    },
    languagePosition () {
      return this.companyThemeSetting?.companyDetailSetting?.languagePosition || 'right'
    },
    fixedHeader () {
      return this.hasCustomTheme ? this.companyThemeSetting.companyDetailSetting?.fixedHeader : false
    },
    companyLogo () {
      const company = this.companyInfo
      if (this.companyThemeSetting) {
        return this.headerSetting.logoImage
          ? this.headerSetting.logoImage.url
          : company
            ? this.$DjangoBaseUrl(company.logo)
            : null
      }
      return require('@/assets/image/ajinga_logo_black.png')
    },
    headerStyle () {
      const userMenuBackgroundColor = this.headerSetting.userMenu?.backgroundColor
      const userMenuFontColor = this.headerSetting.userMenu?.fontColor
      const style = {
        '--header-background-color': this.headerSetting.headerBackgroundColor,
        '--header-font-color': this.headerSetting.headerFontColor || '#606266',
        '--header-height': this.headerSetting.headerHeight ? `${this.headerSetting.headerHeight}px` : null,
        '--user-menu-background-color': userMenuBackgroundColor,
        '--user-menu-border-color': (userMenuBackgroundColor && _.toUpper(this.headerSetting.headerBackgroundColor) !== _.toUpper(userMenuBackgroundColor)) ? this.headerSetting.headerBackgroundColor : null,
        '--user-menu-border-radius': (userMenuBackgroundColor && _.toUpper(this.headerSetting.headerBackgroundColor) !== _.toUpper(userMenuBackgroundColor)) ? '4px' : null,
        '--user-menu-font-color': userMenuFontColor,
        '--logo-width': this.headerSetting.logoWidth ? `${this.headerSetting.logoWidth}px` : null,
        '--background-color': this.loginSetting.backgroundColor,
        '--custom-color': this.commonSetting.customColor
      }
      return style
    }
  },
  created () {
  },
  methods: {
    ...mapActions('common', ['changeLanguage']),
    ...mapGetters('account', ['getCurrentAccount']),
    onLanguageBtnClick () {
      if (this.isPreview) {
        return
      }
      let languageParam = 'en'
      if (isEn()) {
        this.$i18n.locale = 'zh'
        languageParam = 'zh-cn'
      } else {
        this.$i18n.locale = 'en'
      }
      this.changeLanguage(languageParam)
      this.$emit('changeLanguage')
    },
    handleOpenHome () {
      this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
    },
    isActiveCustomMenu (path) {
      if (!path.startsWith('http')) {
        path = `${window.location.origin}${path}`
      }
      if (path.includes('/company-detail-new/')) {
        path = path.replace('/company-detail-new/', '/recruiting/company-detail/')
      }
      path = new URL(path)
      let menuPathName = path.pathname
      const menuSearch = path.search
      const menuHost = path.host
      let windowPathName = window.location.pathname
      const windowSearch = window.location.search
      const windowHost = window.location.host
      if (menuPathName.endsWith('/')) {
        menuPathName = menuPathName.substring(0, menuPathName.length - 1)
      }
      if (windowPathName.endsWith('/')) {
        windowPathName = windowPathName.substring(0, windowPathName.length - 1)
      }
      return menuPathName === windowPathName && menuSearch === windowSearch && menuHost === windowHost
    },
    isActive (menu) {
      if (menu.name && menu.name === COMPANY_PAGE_TYPE.JOB_LIST && this.$route.meta?.pageType === COMPANY_PAGE_TYPE.JOB_DETAIL) {
        return true
      } else if (this.$route.path === `/recruiting/company-detail/${this.companyInfo.id}` && menu.pageNum === _.parseInt(this.currentPageNum)) {
        return true
      } else if (menu.name && menu.name === this.$route.meta?.pageType) {
        return true
      }
      return false
    }
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
$navigation-size: 24px;
$safe-blank: 15px;

.layout-head {
  display: flex;
  height: var(--header-height, 124px);
  line-height: var(--header-height, 124px);
  padding: 0 40px;
  align-items: center;
  font-size: 16px;
  box-sizing: content-box;
  color: var(--header-font-color, #606266);
  background-color: var(--header-background-color, #fff);

  &::after {
    content: '';
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
  }

  .company-info {
    .company-logo-wrapper {
      display: inline-block;
      width: 165px;
      overflow: hidden;
      vertical-align: middle;

      &.has-company-logo {
        width: var(--logo-width, 80px);
        height: var(--logo-width, 80px);
        border-radius: 50%;
      }

      .company-logo {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .company-name {
      display: inline-block;
      max-width: 250px;
      margin-left: $safe-blank;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: keep-all;
    }
  }

  .menu-list {
    flex: 1;
    display: flex;
    margin: 0 $safe-blank 0 60px;
    overflow: hidden;
    float: left;

    .menu {
      display: block;
      margin: 0 30px;
      white-space: nowrap;
      word-break: keep-all;
      text-overflow: ellipsis;
      overflow: hidden;
      color: var(--header-font-color, #000);
      line-height: 24px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &.is-custom-menu {
        box-sizing: initial;
        padding: 4px;
      }

      &.is-active {
        padding-bottom: 4px;
        border-bottom: 1px solid var(--header-font-color, var(--custom-color));
      }

    }
  }

  .navigation-container {
    display: flex;
    margin-left: $safe-blank;

    .navigation {
      height: $navigation-size;
      line-height: $navigation-size;
      padding: 0 20px;
      border-left: 1px solid #d7dadf;
      cursor: pointer;

      &:first-child {
        border-left-color: transparent;
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }

      &.login {
        color: var(--header-font-color, var(--custom-color));
      }

      &.language {
        color: var(--header-font-color, var(--custom-color));
      }

      .navigation-icon {
        color: #929292;
        font-size: $navigation-size;
        font-weight: normal;
      }

      &.contact {
        position: relative;

        .hotline-icon {
          font-size: 24px;
          cursor: pointer;
          color: #939393;

          &:hover {
            ~ .dropdown-container {
              display: block;
            }
          }
        }

        .hotline-list {
          .detail-line {
            height: 22px;
            line-height: 22px;
            word-break: keep-all;
            white-space: nowrap;

            .line-label {
              display: inline-block;
              width: 85px;
              color: #333;
            }

            .line-content {
              margin-left: 10px;
              font-size: 14px;

              &.phone {
                color: #ff6633;
              }
              &.email{
                text-decoration: underline;
              }
            }
          }
        }

        .dropdown-container {
          display: none;
          margin-top: 20px;
          padding: 10px 15px;
          border: 1px solid #aaa;
          border-radius: 10px;
          background: #fff;
          cursor: pointer;
          position: absolute;
          top: 100%;
          right: -18px;
          z-index: 10;
          font-size: 14px;

          &:hover {
            display: block;
          }

          .dropdown-arrow {
            width: 22px;
            height: 15px;
            background: url($baseDomain + 'static/image/list_assets.png?t=5') no-repeat -20px -142px;
            position: absolute;
            top: -13px;
            right: 18px;
          }

          .dropdown-padding {
            width: 35px;
            height: 30px;
            position: absolute;
            top: -30px;
            right: 14px;
          }
        }
      }
    }

    .user-menu-dropdown {
      background: initial;
      top: 0;

      ::v-deep {
        .dropdown-label {
          width: initial;
          background: initial;
          line-height: 24px;
          height: 24px;
        }

        .dropdown-list {
          width: 160px;
          top: 42px;
          right: -56px;
          z-index: 5;

          .dropdown-item {
            font-size: 14px;
          }
        }
      }
    }

    .account-type-selector {
      position: relative;

    .dropdown-list {
      width: 160px;
      margin-top: 6px;
      border: 1px solid #d8dce6;
      background: var(--user-menu-background-color, #fff);
      color: var(--user-menu-font-color, #606266);
      position: absolute;
      top: 100%;
      right: -68px;
      z-index: 5;

      .dropdown-item {
        padding: 4px 13px;
        line-height: 20px;
        cursor: pointer;

        &:hover {
          background: #f0f0f0;
        }

        &.is-active {
          background: #0096cc;
          color: #ffffff;
        }
      }
    }
    }
  }

  .header-center {
    width: fit-content;
    margin: 0 auto;
  }

  &.center-style {
    display: block;
    margin: 0;

    .menu-list {
      float: left;
      margin: 0;
      height: 100%;
      align-items: center;
    }

    .navigation-container {
      float: right;
      height: 100%;
      align-items: center;
    }
  }

  &.fixed-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
  }

  .need-left-spacing {
      margin-left: 20px;
    }
}

.user-menu {
  background: var(--user-menu-background-color, #fff);
  color: var(--user-menu-font-color, #606266);

  .dropdown-item {
    &:hover {
      background: #f0f0f0;
    }

    &.is-active {
      background: #0096cc;
      color: #ffffff;
    }
  }

  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
}
</style>
